
import { defineComponent, onMounted } from 'vue'
import PaymentAdminApi from '@/core/services/payment/PaymentAdminApi'
import { usePaginatedList } from '@/core/composables/usePaginatedList'
import { formatDateTime } from '@/core/helpers/paymentFormat'
import { AuditEntry } from '@/core/services/payment/types'
import { auditActionLabel } from '@/core/services/payment/labels'
import PaymentListLayout from '@/core/components/payment/PaymentListLayout.vue'

/** Журнал действий (только чтение): записи не меняются и не удаляются. */
export default defineComponent({
  name: 'PaymentsAudit',
  components: { PaymentListLayout },
  setup() {
    const list = usePaginatedList<AuditEntry>(PaymentAdminApi.audit.list, {
      perPage: 50,
      defaults: { actor_id: '', action: '', subject_type: '', subject_id: '', from: '', to: '' },
    })
    onMounted(list.init)
    return { ...list, dateTime: formatDateTime, actionLabel: auditActionLabel }
  },
})
